var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.317 14.2936C13.4963 8.23377 22.0446 6.3024 29.3261 9.54686C30.3351 9.99642 31.5174 9.54294 31.967 8.534C32.4165 7.52505 31.9631 6.3427 30.9541 5.89314C22.0545 1.9277 11.6066 4.28826 5.27631 11.6947C-1.05399 19.1011 -1.75875 29.7891 3.54421 37.9627C8.84717 46.1362 18.8946 49.8482 28.2379 47.0857C37.5812 44.3232 43.9945 35.7443 44.0001 26.0011V24.14C44.0001 23.0354 43.1047 22.14 42.0001 22.14C40.8955 22.14 40.0001 23.0354 40.0001 24.14V25.9989C39.9956 33.9705 34.7482 40.9896 27.1037 43.2499C19.4592 45.5101 11.2386 42.473 6.89983 35.7856C2.56104 29.0981 3.13766 20.3534 8.317 14.2936Z",
    fill: "#4EBC66"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4142 9.4142C46.1953 8.63315 46.1953 7.36682 45.4142 6.58577C44.6332 5.80472 43.3668 5.80472 42.5858 6.58577L22 27.1716L17.4142 22.5858C16.6332 21.8047 15.3668 21.8047 14.5858 22.5858C13.8047 23.3668 13.8047 24.6331 14.5858 25.4142L20.5858 31.4142C21.3668 32.1952 22.6332 32.1952 23.4142 31.4142L45.4142 9.4142Z",
    fill: "#4EBC66"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.2b921314.svg";
export { ForwardRef as ReactComponent };